export const EMOTION_EMOJI = {
  neutral: "😐",
  happy: "😊",
  sad: "😢",
  angry: "😠",
  fear: "😨",
  surprise: "😲",
  disgust: "🤢",
  focused: "🧐",
};

export const COGNITIVE_LABELS = {
  engaged: "👀 Engaged",
  focus: "🎯 Deep Focus",
  unengaged: "💤 Not Looking",
  out_of_frame: "❌ No Face",
};

export const CALIBRATION_THEMES = {
  clarity: ['#0ea5e9', '#22d3ee', '#38bdf8'],
  passion: ['#e11d48', '#f43f5e', '#fb7185'],
  happy:   ['#f59e0b', '#fbbf24', '#fcd34d'],
  neutral: ['#8b5cf6', '#a78bfa', '#c4b5fd'],
  yawn:    ['#84905e', '#a3ad7c', '#bac39a'],
  surprise:['#ea580c', '#f97316', '#fb923c'],
  sad:     ['#5b6c9a', '#7f92bf', '#a8b4ce'],
  focused: ['#0891b2', '#22d3ee', '#67e8f9'],
};

export const CALIBRATION_WINDOW_PALETTES = {
  passion: {
    surfaceA: 'rgba(68, 12, 26, 0.72)',
    surfaceB: 'rgba(20, 6, 11, 0.92)',
    border: 'rgba(251, 113, 133, 0.34)',
    soft: 'rgba(251, 113, 133, 0.14)',
    text: '#ffe4e6',
  },
  clarity: {
    surfaceA: 'rgba(8, 47, 73, 0.72)',
    surfaceB: 'rgba(3, 19, 32, 0.92)',
    border: 'rgba(125, 211, 252, 0.34)',
    soft: 'rgba(125, 211, 252, 0.14)',
    text: '#e0f2fe',
  },
  happy: {
    surfaceA: 'rgba(92, 49, 4, 0.72)',
    surfaceB: 'rgba(27, 15, 4, 0.92)',
    border: 'rgba(252, 211, 77, 0.36)',
    soft: 'rgba(252, 211, 77, 0.14)',
    text: '#fffbeb',
  },
  neutral: {
    surfaceA: 'rgba(56, 33, 99, 0.72)',
    surfaceB: 'rgba(18, 9, 36, 0.92)',
    border: 'rgba(196, 181, 253, 0.36)',
    soft: 'rgba(196, 181, 253, 0.14)',
    text: '#f3e8ff',
  },
  yawn: {
    surfaceA: 'rgba(58, 66, 41, 0.72)',
    surfaceB: 'rgba(19, 23, 14, 0.92)',
    border: 'rgba(186, 195, 154, 0.34)',
    soft: 'rgba(186, 195, 154, 0.14)',
    text: '#f7fee7',
  },
  surprise: {
    surfaceA: 'rgba(98, 33, 20, 0.72)',
    surfaceB: 'rgba(32, 10, 7, 0.92)',
    border: 'rgba(255, 138, 111, 0.36)',
    soft: 'rgba(255, 138, 111, 0.14)',
    text: '#fff7ed',
  },
  sad: {
    surfaceA: 'rgba(31, 42, 70, 0.72)',
    surfaceB: 'rgba(12, 17, 30, 0.92)',
    border: 'rgba(147, 164, 207, 0.36)',
    soft: 'rgba(147, 164, 207, 0.14)',
    text: '#eef2ff',
  },
  focused: {
    surfaceA: 'rgba(8, 52, 74, 0.72)',
    surfaceB: 'rgba(4, 21, 32, 0.92)',
    border: 'rgba(103, 232, 249, 0.34)',
    soft: 'rgba(103, 232, 249, 0.14)',
    text: '#ecfeff',
  },
};

export const EMOTION_BUCKET = {
  happy: 'happy',
  sad: 'sad',
  angry: 'angry',
  fear: 'sad',
  disgust: 'angry',
  surprise: 'surprise',
  focused: 'focused',
  neutral: 'neutral',
  yawn: 'yawn',
};

export const makeCaptureSessionId = () => `sess-${new Date().toISOString().replace(/[:.]/g, '-')}`;
